import React from 'react'
import { PageHeader } from "antd";
import ProgramTransfer from '../../components/enrollment/ProgramTransfer';
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const TransferProgramme = () => {
  return (
    <div className="inside-main-content">
    <AdminBreadCrumb />

    <div className="box-style">
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Transfer Your Programme"
        subTitle=""
        extra={[]}
      ></PageHeader>

      <ProgramTransfer />

    </div>
  </div>
  )
}

export default TransferProgramme